angular.module('workflow.app')

.factory( 'SearchResult', ( Model, Translator, Utils, $sce ) ->

  class SearchResult extends Model

    init: () ->
      if @can_be_translated
        @translate()

    shouldBeTranslated: ->
      @can_be_translated && Translator.shouldTranslate @

    translate: ->
      Translator.translateResult @

    hasUrl: () ->
      @hasOwnProperty( 'url' ) and @url != null and @url != "" and
      !(@hasOwnProperty( 'private_source' ) and @private_source == 'True')

    hasPublishDate: () ->
      @hasOwnProperty( 'published_date' ) and @published_date != null

    hasTitle: () ->
      @title? && @title != ''

    getTitle: () ->
      if @hasTitle() then @title else 'Untitled'

    getTrustedTitle: () ->
      $sce.trustAsHtml(@getTitle())

    getTitleTranslated: () ->
      if @hasTitle() then @titleTranslated else 'Untitled'

    hasScore: () ->
      return @getScore()?

    getScore: () ->
      return @score

    isMLRelevant: () ->
      return @ml_relevant

    hasSnippet: () ->
      @hasOwnProperty( 'snippet' ) and !!@snippet

    getTrustedSnippet: () ->
      $sce.trustAsHtml(@snippet)

    hasExtras: () ->
      @hasOwnProperty( 'extra' ) and not Utils.isEmptyObject( @extra )

    isFactivaResult: () ->
      if @hasUrl()
        if /factiva\.com/.test( @url )
          return true
      return false

    isPepDeskResult: () ->
      if @hasUrl()
        if /info4c\.net/.test( @url )
          return true
      return false


)
